import React, { useMemo } from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

import { buildLeafletLayer, buildLeafletLayerFromCswGeom } from 'src/scenes/Project/scenes/Analytics/smaAnalyticsHelper';
import { MapWrapper } from 'src/components';
import { getColorScheme } from 'src/utils/colorBrewer';
import { getCombinedBounds } from 'src/components/map/mapHelper';
import { thousandsDotAndDecimalComma as tdadc } from 'src/utils/util';


const heightVH = n => document.documentElement.clientHeight * (n / 100);

const mapOptions = {
  center: [ -32.48431324745671, -71.25296320202341 ],
  zoomControl: true,
  dragging: true,
  zoom: 16,
  doubleClickZoom: false,
  attributionControl: false,
};

const useStyles = makeStyles(theme => ({
  map: {
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
  },
}));

const interestAreaMapHeight = 50;

const NationalInventoryWetlands = ({ nationalInventoryWetlands, interestArea = [] }) => {

  const nationalInventoryWetlandsCount = nationalInventoryWetlands.results.length;
  const hasNationalInventoryWetlands = nationalInventoryWetlandsCount > 0;

  const interestAreaLayers = useMemo(() =>
    interestArea.map(ia => buildLeafletLayer({
      features: ia.geojson,
      id: ia.id,
      name: ia.name,
    }))
  , [ interestArea ]);

  const colors = useMemo(() => getColorScheme(nationalInventoryWetlandsCount), [ nationalInventoryWetlandsCount ]);

  const nationalInventoryWetlandsForMap = useMemo(
    () => hasNationalInventoryWetlands ? nationalInventoryWetlands.results : [ nationalInventoryWetlands.closest ],
    [ nationalInventoryWetlands, hasNationalInventoryWetlands ],
  );

  const nationalReservesLayers = useMemo(() =>
    nationalInventoryWetlandsForMap.map((pl, index) =>
      buildLeafletLayerFromCswGeom({
        features: [ pl.cswFeatGeom ],
        id: pl.code,
        name: pl.name,
        style: {
          weight: 2,
          fillOpacity: 0.8,
          color: colors[index],
          fillColor: colors[index],
        },
      }),
    )
  , [ nationalInventoryWetlandsForMap, colors ]);

  const classes = useStyles();

  const zoomTo = getCombinedBounds([ ...interestAreaLayers, ...(hasNationalInventoryWetlands ? nationalReservesLayers : []) ]);

  return (
    <Box mt={1}>
      <MapWrapper
        id="national-inventory-wetlands-map"
        className={classes.map}
        options={mapOptions}
        height={heightVH(interestAreaMapHeight)}
        layers={[ ...nationalReservesLayers, ...interestAreaLayers ]}
        {...(hasNationalInventoryWetlands ? { box: nationalInventoryWetlands.box } : {})}
        bounds={zoomTo}
        fitBoundsOnUpdate
      />
      <Box mt={1} mb={hasNationalInventoryWetlands ? 3 : 1}>
        <Typography variant="caption" color="textPrimary">
          {nationalInventoryWetlandsCount > 0 ?
            <>El área de interés interseca con {nationalInventoryWetlandsCount} reservas nacionales</>
            :
            <>
              El área de interés NO interseca con ningun humedal dentro de {tdadc(nationalInventoryWetlands.bufferInKm.toFixed(2))} km,
              el más cercano se encuentra a {tdadc(nationalInventoryWetlands.closest.distanceInKm.toFixed(2))} km
            </>
          }
        </Typography>
      </Box>
      {/* <Cards values={pliscoff.results} columns={columns} variant="condensed" componente /> */}
    </Box>
  );
};

NationalInventoryWetlands.propTypes = {
  nationalInventoryWetlands: PropTypes.object,
  interestArea: PropTypes.array,
};


export {
  NationalInventoryWetlands,
};